import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Toaster } from "react-hot-toast";
import store from "./redux/store";
import { Provider } from "react-redux";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    {/* <GoogleOAuthProvider clientId="375220227786-1mq10irrsivh7lj6s5m1b7uclntit1kk.apps.googleusercontent.com"> */}
    {/* <GoogleOAuthProvider clientId="1083740285274-tvvsachfqqlh5o9818f77dh55kko0nvs.apps.googleusercontent.com"> */}
    <GoogleOAuthProvider clientId="307508690433-7iirescjet3ltcglu0amjai1vp7h25vi.apps.googleusercontent.com">
      <Provider store={store} >
        <App />
      </Provider>
    </GoogleOAuthProvider >
    <Toaster
      position="bottom-right"
      reverseOrder={true}
      toastOptions={{
        style: {
          zIndex: 11000, 
        },
      }}
    />
  </>
);

document.addEventListener("DOMContentLoaded", function () {
  const isDark = localStorage.getItem("isDark");
  // console.log('isDark', isDark);

  if (isDark === true) {
    document.body.style.backgroundColor = "#000";
    const modalElement = document.querySelector('.modal-header'); // Replace with your modal class or ID
    // if (modalElement) {
    modalElement.style.backgroundColor = "#121212 !important";
    // }
    document.body.style.color = "#202020";
    // import("flatpickr/dist/themes/dark.css");
  } else {
    document.body.style.backgroundColor = " #F5F5F5";
    document.body.style.backgroundColor = "#f9f7f7";
    // import("flatpickr/dist/themes/light.css");
    const modalElement = document.querySelector('.modal-header'); // Replace with your modal class or ID
    if (modalElement) {
      modalElement.style.backgroundColor = "#ffffff !important";
    }
  }
});

